module.exports = __webpack_public_path__ + "static/img/cont218.04d804b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont218.jpg
// module id = t9Dt
// module chunks = 0